<div class="applicationlist">
    <ng-container>
      <div class="data-loader-container" style="stroke:  #002677 !important;" *ngIf="viewClickLoader">
        <app-loader></app-loader>
      </div>
      <div *ngIf="!viewClickLoader">
        
        <div class="row no-gutters col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 container-fluid" style="padding-top: 16px;">
          <div class="col-md-8 col-sm-12 col-lg-8 col-xl-8 col-xs-8">
            <p style="font-size: 15px !important;"> <b class="tabl-header">Group Model:</b> {{model}}<b class="tabl-header"> Capability: </b>{{capability}}<b class="tabl-header"> Organization: </b>{{organisationName}}<p>
          </div>
          
        </div>
          
        <ng-container>
          <app-table-data [SelectAll]="false" [displaySelectAll]="false" [dataSource]="dataSource"
            [columns]="displayedColumns" [pageSize]="pageSize">
          </app-table-data>
        </ng-container>
      </div>
    </ng-container>
  </div>
  